import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { IRootStore, IUserState } from '../types';


const state: IUserState = {
  profile: null,
};

export const user: Module<IUserState, IRootStore> = {
  getters,
  actions,
  mutations,
  state,
};
